var _circle, _circle2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkinSpecialistIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.2871,
    cy: 22.7861,
    r: 12,
    stroke: "#0052FD",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.2866,
    cy: 22.7866,
    r: 9.71428,
    stroke: "#0052FD",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5148 30.2148L35.672 34.372C36.169 34.869 36.169 35.6749 35.672 36.172V36.172C35.1749 36.669 34.369 36.669 33.872 36.172L29.7148 32.0148",
    stroke: "#0052FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2857 32.5L32 34.7857",
    stroke: "#0052FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0432 34.033V34.033C24.0432 35.7113 22.6827 37.0718 21.0044 37.0718H12.6319C11.1419 37.0718 9.93396 35.8639 9.93396 34.3739V32.535C9.93396 30.385 9.05236 28.329 7.49486 26.8468L6.17679 25.5925C4.42262 23.9231 3.42969 21.6075 3.42969 19.186V14.3088C3.42969 13.2035 4.32571 12.3074 5.431 12.3074V12.3074C6.5363 12.3074 7.43232 13.2035 7.43232 14.3088V18.8834V5.99306C7.43232 4.7496 8.44034 3.74158 9.6838 3.74158V3.74158C10.9273 3.74158 11.9353 4.7496 11.9353 5.99306V9.74176V4.98758C11.9353 3.77175 12.9209 2.78613 14.1367 2.78613V2.78613C15.3526 2.78613 16.3382 3.77175 16.3382 4.98758V9.74176V6.41652C16.3382 5.20069 17.3238 4.21507 18.5396 4.21507V4.21507C19.7554 4.21507 20.7411 5.20069 20.7411 6.41652V10.5972V7.55819C20.7411 6.34236 21.7267 5.35674 22.9425 5.35674V5.35674C24.1583 5.35674 25.144 6.34236 25.144 7.55819L25.144 11.4417M24.0432 32.5004L24.0432 29.2333C24.0432 27.6716 24.228 26.1154 24.5936 24.5971V24.5971C24.9592 23.0788 25.144 21.5225 25.144 19.9608V13.4369",
    stroke: "#0052FD",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1445 20.9157V21.3969M21.7159 17.6436V18.1248M19.5296 18.4135V18.8947M21.7159 20.5308V21.012M19.5296 21.3007V21.7819M21.7159 23.418V23.8992M19.5296 24.1879V24.6691M21.7159 26.3052V26.7864M17.1445 23.6105V24.0917M17.1445 26.3052V26.7864",
    stroke: "#00E500",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinSpecialistIcon);
export default __webpack_public_path__ + "static/media/SkinSpecialistIcon.19125e75d18e45f1cd1e6d425800b523.svg";
export { ForwardRef as ReactComponent };